<div class="row">
  <div class="col-12">
    <h1>Platform / Progress indicator</h1>
  </div>
</div>

<div class="row">
  <div class="col-12">
    <h2>Line</h2>
    <p>Line progress indicator can display a progress in range of 0-100 as a line. Line indicator uses the full-width of a provided container.</p>
    <div class="indicator-line-row">
      <div class="w-100">
        <ui-platform-progress-indicator-line [progress]="30"></ui-platform-progress-indicator-line>
        <ui-platform-progress-indicator-line [progress]="3"></ui-platform-progress-indicator-line>
        <ui-platform-progress-indicator-line [progress]="89"></ui-platform-progress-indicator-line>
      </div>
      <div class="w-50">
        <ui-platform-progress-indicator-line [progress]="1"></ui-platform-progress-indicator-line>
        <ui-platform-progress-indicator-line [progress]="67"></ui-platform-progress-indicator-line>
        <ui-platform-progress-indicator-line [progress]="100"></ui-platform-progress-indicator-line>
      </div>
    </div>
    <h3>Color</h3>
    <p>Two colors are supported <code>primary</code> (default), <code>grey</code></p>
    <div class="w-50">
      <ui-platform-progress-indicator-line [progress]="67"></ui-platform-progress-indicator-line>
      <ui-platform-progress-indicator-line
        [color]="'grey'"
        [progress]="43"></ui-platform-progress-indicator-line>
    </div>

    <h3>Template usage</h3>
    <pre
      >{{
        '' +
          '&lt;ui-platform-progress-indicator-line\n' +
          '  [progress]="\43"\n' +
          '  [color]="\'primary\'"\n' +
          '&gt;\n' +
          '&lt;/ui-platform-progress-indicator-line&gt;'
      }}
</pre
    >

    <h2>Circle</h2>
    <p>Circle progress indicator can display a progress in range of 0-100 as a partially filled circle.</p>

    <div class="indicator-line-row">
      <div class="w-100 circle-row">
        <ui-platform-progress-indicator-circle [progress]="30"></ui-platform-progress-indicator-circle>
        <ui-platform-progress-indicator-circle [progress]="1"></ui-platform-progress-indicator-circle>
        <ui-platform-progress-indicator-circle [progress]="99"></ui-platform-progress-indicator-circle>
      </div>
    </div>

    <h3>Template usage</h3>
    <pre
      >{{ '' + '&lt;ui-platform-progress-indicator-circle\n' + '  [progress]="\43"\n' + '&gt;\n' + '&lt;/ui-platform-progress-indicator-circle&gt;' }}
</pre
    >
  </div>
</div>
